import styles from './FooterCell.module.scss';

import { Header } from '@tanstack/react-table';
import clsx from 'clsx';
import React from 'react';

import { ICssClasses } from '../../../../types';
import { getCommonPinningStyles } from '../../../get-common-pinning-styles';
import { ITableCellProps, TableCell } from '../../../table-cell/TableCell';
import { FooterCellContentV8 } from '../footer-cell-content/FooterCellContentV8';
import { FooterCellWrapper } from '../footer-cell-wrapper/FooterCellWrapper';

interface FooterCellV8Props {
  header: Header<unknown, unknown>;
  cellRef?: React.ForwardedRef<HTMLDivElement>;
  rootRef?: React.ForwardedRef<HTMLDivElement>;
  cellProps?: ITableCellProps;
  classes?: ICssClasses;
  contentCellProps?: Record<string, number>;
}

export function FooterCellV8(props: FooterCellV8Props) {
  const { header, rootRef, cellRef, cellProps } = props;

  return (
    <div
      key={header.id}
      ref={rootRef}
      className={styles.headerCellRoot}
      style={getCommonPinningStyles(header.column)}
    >
      <FooterCellWrapper>
        <TableCell
          className={clsx(styles['cell'])}
          dataType={header.column.columnDef.dataType}
          alignment={header.column.columnDef.alignment}
          ref={cellRef}
          {...cellProps}
        >
          <FooterCellContentV8
            header={header}
            cellProps={props.contentCellProps}
          />
        </TableCell>
      </FooterCellWrapper>
    </div>
  );
}
